import { isNil } from 'lodash';

interface IApiErrorOptions {
  details?: string;
  errors?: any[];
  message?: string;
  requestBody?: string;
  status?: number;
  statusText?: string;
}

class ApiError extends Error {
  details?: string;

  errors?: any[];

  status?: number;

  statusText?: string;

  constructor(options: IApiErrorOptions) {
    super(options.message || 'Server error');
    this.details = options.details;
    this.errors = options.errors;
    this.status = options.status;
    this.statusText = options.statusText;
  }

  logDetails = () => {
    const errors = isNil(this.errors)
      ? ''
      : `\nErrors Details: ${JSON.stringify(this.errors)}`;
    const message = `Message: ${this.message}`;
    const status = isNil(this.status) ? '' : `\nStatus: ${this.status}`;
    const statusText = isNil(this.statusText)
      ? ''
      : `\nStatus Text: ${this.statusText}`;
    const details = message + status + statusText + errors;
    // eslint-disable-next-line no-console
    console.log(details);
  };
}

export default ApiError;
